import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightbulbIconNavy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 21,
	viewBox: "0 0 22 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.8688 4.2327L17.5077 2.88663L15.7799 4.60501L17.1409 5.95107L18.8688 4.2327ZM11.6773 3.36396H9.74675V0.5H11.6773V3.36396ZM21.3303 11.9558H18.4344V10.0465H21.3303V11.9558ZM9.74675 18.5907V14.8103L8.78145 14.2566C7.58448 13.5692 6.85086 12.3091 6.85086 10.9535C6.85086 8.84368 8.57874 7.13485 10.712 7.13485C12.8454 7.13485 14.5732 8.84368 14.5732 10.9535C14.5732 12.3091 13.83 13.5692 12.6426 14.2566L11.6773 14.8103V18.5907H9.74675ZM7.81616 20.5H13.6079V15.9081C15.3358 14.9153 16.5038 13.0728 16.5038 10.9535C16.5038 7.79356 13.9072 5.22554 10.712 5.22554C7.51691 5.22554 4.92026 7.79356 4.92026 10.9535C4.92026 13.0728 6.08827 14.9153 7.81616 15.9081V20.5ZM2.98967 11.9558H0.0937748V10.0465H2.98967V11.9558ZM5.65389 4.59547L3.926 2.87709L2.56494 4.22315L4.30247 5.93198L5.65389 4.59547Z",
		fill: "#004F87"
	})
});
export default SvgLightbulbIconNavy;
